import layout from '@/layout'
// import { _l } from '@/i18n'
const meta = { auth: true, cache: true, head: { back: true } }

export default {
  path: '/ecomSys',
  component: layout,
  meta: {
    funcID: 'E0009',
    PID: 'E00',
  },
  children: ((pre) => [
    {
      path: 'thirdPartyApiSet',
      name: `${pre}thirdPartyApiSet`,
      meta: {
        ...meta,
        head: { back: false },
        funcID: 'E000901',
        PID: 'E00',
      },
      component: () => import('@/views/ecom/sys/thirdPartyApiSet'),
    },
    {
      path: 'userThirdPartyApiSet',
      name: `${pre}userThirdPartyApiSet`,
      meta: {
        ...meta,
        head: { back: false },
        funcID: 'E000902',
        PID: 'E00',
      },
      component: () => import('@/views/ecom/sys/userThirdPartyApiSet'),
    },
    {
      path: 'thirdPartyApiSet/:pageType/:code?',
      name: `${pre}thirdPartyApiSet-detail`,
      meta: {
        ...meta,
        title:  () => {
          return `三方系统接口定义`
        },
        funcID: 'E000901',
        PID: 'E00',
        pageConfig: { layout: { class: 'bg-transparent p-0', bodyClass: 'p-0' } },
      },
      component: () => import('@/views/ecom/sys/thirdPartyApiSet/detail'),
    },
    {
      path: 'platformOrder',
      name: `${pre}platformOrder`,
      meta: {
        ...meta,
        head: { back: false },
        funcID: 'E000903',
        PID: 'E00',
      },
      component: () => import('@/views/ecom/sys/platformOrder'),
    },
    {
      path: 'platformOrderLog',
      name: `${pre}platformOrderLog`,
      meta: {
        ...meta,
        head: { back: false },
        funcID: 'E000904',
        PID: 'E00',
      },
      component: () => import('@/views/ecom/sys/platformOrderLog'),
    },
    {
      path: 'amzApp',
      name: `${pre}amzApp`,
      meta: {
        ...meta,
        head: { back: false },
        funcID: 'E000905',
        PID: 'E00',
      },
      component: () => import('@/views/ecom/sys/amzApp'),
    },
    {
      path: 'amzApp/:pageType/:amzAppCode?',
      name: `${pre}amzApp-detail`,
      meta: {
        ...meta,
        funcID: 'E000905',
        PID: 'E00',
        pageConfig: {
          layout: { class: 'bg-transparent p-0', bodyClass: 'p-0' },
        },
      },
      component: () => import('@/views/ecom/sys/amzApp/detail'),
    },
    {
      path: 'amzReportRecord',
      name: `${pre}amzReportRecord`,
      meta: {
        ...meta,
        head: { back: false },
        funcID: 'E000906',
        PID: 'E00',
      },
      component: () => import('@/views/ecom/sys/amzReportRecord'),
    },
    {
      path: 'transformTemplate',
      name: `${pre}transformTemplate`,
      meta: {
        ...meta,
        head: { back: false },
        funcID: 'E000907',
        PID: 'E00',
      },
      component: () => import('@/views/ecom/sys/transformTemplate'),
    },
  ])('ecom-sys-'),
}
